// importaciones geneales
const moment = require('moment');

/**
 * Datos predefinidos para el pago.
 * 
 * @return Object
 * @author Fernando Claros
 */
export const dataInitialMonthlyPayment = () => {

  const date_start  = moment().format('yyyy-MM-DD');
  const date_end    = moment().add(30, 'days').format('yyyy-MM-DD');

  return {
    id: null,
    dates: [date_start, date_end],
    quantity_hours: 0,
    description: "",
    is_active: 1,
    slq_company_id: null,
    slq_license_id: null,
    action: 'CREATE'
  }
};

/**
 * Datos predefinidos para el filtro de los datos actuales en el historico.
 * 
 * @return Object
 * @author Fernando Claros
 */
export const dataInitialFilter = () => {
  return {
    param: '',
    page: 1,
    sortBy: 'date_start',
    sort: 'asc',
    per_page: 10,
    total: 0
  };
};

/**
 * Estados.
 * 
 * @return Object
 * @author Fernando Claros
 */
export default {
  activedTabMonthlyPayment: 1,
  isShowFormMonthlyPayment: false,
  filter: dataInitialFilter(),
  monthlyPayment: dataInitialMonthlyPayment(),
  monthlyPayments: []
};
